import { ReferenceSkeleton } from 'pages/Conversation/components/ReferenceSkeleton'
import { useTranslation } from 'services/i18n'
import { Message, MessageReference } from 'types/Api'

import { Reference } from './Reference'
import { ReferenceScrollWrapper } from './ReferenceScrollWrapper'
import { ReferencesPanelError } from './ReferencesPanelError'

import type { FC } from 'react'

type Props = {
  isCanceled: boolean
  isProcessing: boolean
  messageId: string
  messageStatus: Message['status']
  references: MessageReference[]
}

export const ReferencesPanelBody: FC<Props> = ({
  isCanceled,
  isProcessing,
  messageId,
  messageStatus,
  references,
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'conversation.references_panel',
  })

  if ((isCanceled || messageStatus === 'success') && !references.length) {
    return <div className="mb-6 px-6">{t('empty_state')}</div>
  }

  if (messageStatus === 'error') return <ReferencesPanelError />

  return (
    <div className="mb-3">
      <ul>
        {references.map(reference => (
          <ReferenceScrollWrapper key={reference.id} messageId={messageId} reference={reference}>
            <Reference messageId={messageId} reference={reference} />
          </ReferenceScrollWrapper>
        ))}
      </ul>
      {isProcessing && <ReferenceSkeleton />}
    </div>
  )
}
